import { object } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Badge, Card, ZendeskLink } from 'components';
import { formatDate, getBadgeColor, getValidDate } from 'helpers';

const TableCard = ({ row }) => {
  const { t } = useTranslation();

  return (
    <Card className="px-6 py-3">
      <div className="flex-start-between flex-wrap gap-x-6 gap-y-2 text-gray-600 font-bold text-sm mb-2">
        <span>{row.partner}</span>

        {row.action && row.url && (
          <ZendeskLink to={row.url} className="btn small text-sm font-semibold">
            <span className="truncate-line one-line">{row.action}</span>
          </ZendeskLink>
        )}
      </div>

      <Badge color={getBadgeColor(row.status)} className="text-sm my-4">
        {row.status}
      </Badge>

      <div className="flex-center-between flex-wrap text-gray-500 font-light">
        <span>{t('dashboard:departureDates', { fromDate: row.fromDate, toDate: row.toDate })}</span>
        <span>{formatDate(getValidDate(row.date))}</span>
      </div>
    </Card>
  );
};

TableCard.propTypes = {
  row: object.isRequired
};

export default TableCard;
